import { render, staticRenderFns } from "./SquarePay.vue?vue&type=template&id=b3d1a028&scoped=true"
import script from "./SquarePay.vue?vue&type=script&lang=js"
export * from "./SquarePay.vue?vue&type=script&lang=js"
import style0 from "./SquarePay.vue?vue&type=style&index=0&id=b3d1a028&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1a028",
  null
  
)

export default component.exports